var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import IconWrapper from "./IconWrapper";
var directions;
(function (directions) {
    directions[directions["bottom"] = 0] = "bottom";
    directions[directions["right"] = 1] = "right";
    directions[directions["left"] = 2] = "left";
    directions[directions["top"] = 3] = "top";
})(directions || (directions = {}));
export default React.forwardRef((_a, ref) => {
    var { color, direction = "bottom", size = "default", sizeRatio } = _a, otherProps = __rest(_a, ["color", "direction", "size", "sizeRatio"]);
    let rotate, sizeRatioNormalized = sizeRatio ? sizeRatio : size === "small" ? 1 : 1.2;
    switch (directions[direction]) {
        case directions.right:
            rotate = 270;
            break;
        case directions.left:
            rotate = 90;
            break;
        case directions.top:
            rotate = 180;
            break;
        default:
            rotate = 0;
            break;
    }
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 20, height: 20, color: color, sizeRatio: sizeRatioNormalized, transform: `rotate(${rotate}deg)` }, otherProps),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L10 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z" })));
});
//# sourceMappingURL=Chevron.js.map